import React from 'react'

import { Anchor } from '../../Anchor/Anchor'
import Progress from '../../Progress/Progress'
import { useGiftCardLinks } from '../../use-gift-card-links/use-gift-card-links'

import '../NavigationDrawer.css'

export const GiftCardLinks = () => {
  const { loading, error, purchaseLink, checkValueLink, addValueEnabled } = useGiftCardLinks()
  if (error) return null
  if (loading) {
    return <Progress eventData={{ category: 'Gift Cards' }} />
  }

  const checkValueLabel = 'Check ' + (addValueEnabled === true ? ' or Add ' : '') + 'Gift Card Value'
  return (
    <React.Fragment>
      {checkValueLink && (
        <li>
          <Anchor
            data-testid='nav-drawer-check-gift-card-balance'
            styleName='listItem'
            href={checkValueLink}
            target='_blank'
            eventData={{
              category: 'Drawer',
              action: 'Check Gift Card Value'
            }}
          >
            {checkValueLabel}
          </Anchor>
        </li>
      )}
      { purchaseLink && (
        <li>
          <Anchor
            data-testid='nav-drawer-buy-gift-card'
            styleName='listItem'
            href={purchaseLink}
            target='_blank'
            eventData={{
              category: 'Drawer',
              action: 'Purchase Gift Cards'
            }}
          >
            Purchase Gift Cards
          </Anchor>
        </li>
      )}
    </React.Fragment>
  )
}
